export enum ProgressBarStatus {
  Neutral = 'neutral',
  Good = 'good',
  Warning = 'warning',
  Error = 'error'
}
